var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBatteryGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 4,
    height: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 2,
    width: 2,
    height: 1,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3.74939C8.5 3.19711 8.05229 2.75 7.5 2.75H7.11111V1.8125C7.11111 1.64 6.98667 1.5 6.83334 1.5L5.16667 1.5C5.01334 1.5 4.88889 1.64 4.88889 1.8125V2.75L4.5 2.75C3.94771 2.75 3.5 3.19706 3.5 3.74934C3.5 5.42566 3.5 8.78849 3.5 10.5031C3.5 11.0554 3.94772 11.5 4.5 11.5H7.5C8.05228 11.5 8.5 11.0553 8.5 10.5031C8.5 8.78931 8.5 5.42594 8.5 3.74939ZM5.44445 2.125H6.55556V2.75L5.44445 2.75V2.125ZM7.94445 10.375C7.94445 10.6511 7.72059 10.875 7.44445 10.875H4.55556C4.27942 10.875 4.05556 10.6511 4.05556 10.375L4.05556 3.875C4.05556 3.59886 4.27942 3.375 4.55556 3.375L7.44445 3.375C7.72059 3.375 7.94445 3.59886 7.94445 3.875L7.94445 10.375Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 6H4.75C4.61193 6 4.5 6.11193 4.5 6.25V10.25C4.5 10.3881 4.61193 10.5 4.75 10.5H7.25C7.38807 10.5 7.5 10.3881 7.5 10.25L7.5 6.25C7.5 6.11193 7.38807 6 7.25 6Z",
    fill: "#61D215"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryGreen);
export default __webpack_public_path__ + "static/media/batteryGreen.644f258ecee955b1dcf90add1374e653.svg";
export { ForwardRef as ReactComponent };